import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { RouterModule, RouterOutlet } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from "@angular/material/icon";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { NavService } from "../../../../../shared/src/lib/services/nav.service";
import { TranslateModule } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrl: "./main.component.scss",
  imports: [CommonModule, FormsModule, RouterModule, RouterOutlet, MatButtonModule, MatSidenavModule, MatIconModule, MatButtonModule, TranslateModule, AsyncPipe],
})
export class MainComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  navService = inject(NavService);
  rightDrawerMode: "side" | "push" = "side";

  constructor(private breakpointObserver: BreakpointObserver) {
    this.observeScreenSize();
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe(["(max-width: 1279px)"]) // Adjust as per your desired breakpoint
      .pipe(takeUntil(this.destroy$))
      .subscribe((state: BreakpointState) => {
        this.rightDrawerMode = state.matches ? "push" : "side";
      });
  }

  observeScreenSize(): void {
    // Observing the screen width breakpoint at 1280px
    this.breakpointObserver
      .observe("(max-width: 1279px)")
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: any) => {
        if (result.matches) {
          // If screen width is below 1280px
          this.navService.openSportsBar.next(false);
          this.navService.openBetSlipBar.next(false);
        } else {
          // If screen width is 1280px or greater
          this.navService.openSportsBar.next(true);
          this.navService.openBetSlipBar.next(true);
        }
      });
  }

  handleSportBar() {
    this.navService.openSportsBar.next(!this.navService.openSportsBar.value);
  }

  handleBetSlip() {
    this.navService.openBetSlipBar.next(!this.navService.openBetSlipBar.value);
    this.navService.openSportsBar.next(false);
  }
  //
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
